import angular from 'angular';
import validations from '../data/validations.json';
import statesOptions from '../data/states.json';
import taxClassifications from '../data/taxClassifications.json';

UpdatePayPacketInformationController.$inject = [
  'ApplicationService',
  '$document',
  '$scope',
  '$rootScope',
  '$location',
  '$window',
  '$q'
];

function UpdatePayPacketInformationController (ApplicationService, $document, $scope, $rootScope, $location, $window, $q) {
  function init () {
    /**
      Note: generalInformation is never sent to the server-side, which means
      it is not there if we perform a GET for the data.

      It simply holds data that'll go under either commissionInformation,
      agencyInformation, or brokerInformation.
    **/

    var formData = ApplicationService.getData();
    $scope.generalInformation = formData.generalInformation;
    $scope.agencyInformation = formData.agencyInformation;
    $scope.brokerInformation = formData.brokerInformation;
    $scope.commissionInformation = formData.commissionInformation;

    $scope.validations = validations;
    $scope.submitForm = submitForm;
    $scope.addressErrorDetails = null;
    $scope.statesOptions = statesOptions;
    $scope.taxClassifications = taxClassifications;
    $scope.previousStep = previousStep;
    $scope.selectAddress = selectAddress;

    var itemsToWatch = [
      'commissionInformation.assignee',
      'agencyInformation.name',
      'brokerInformation.firstName',
      'brokerInformation.middleName',
      'brokerInformation.lastName'
    ];

    $scope.$watchGroup(itemsToWatch, function () {
      if ($scope.commissionInformation.assignee === 'myself') {
        var names = [];
        names.push($scope.brokerInformation.firstName);
        if ($scope.brokerInformation.middleName) {
          names.push($scope.brokerInformation.middleName);
        }
        names.push($scope.brokerInformation.lastName);
        $scope.commissionInformation.assigneeName = (names.join(' '));
      } else {
        $scope.commissionInformation.assigneeName = $scope.agencyInformation.name;
      }
    });

    $rootScope.previouslyAppointed = true;
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  function selectAddress (address) {
    if ($scope.addressErrorDetails.type === 'payee') {
      $scope.generalInformation.assigneeAddress = address.address;
      $scope.generalInformation.assigneeAddress2 = address.address2;
      $scope.generalInformation.assigneeCity = address.city;
      $scope.generalInformation.assigneeState = address.state;
      $scope.generalInformation.assigneeZipCode = address.zipCode;
      $scope.skipPayeeAddress = true;
    } else {
      $scope.commissionInformation.finInstStreetAddress = address.address;
      $scope.commissionInformation.finInstStreetAddress2 = address.address2;
      $scope.commissionInformation.finInstCity = address.city;
      $scope.commissionInformation.finInstState = address.state;
      $scope.commissionInformation.finInstZipCode = address.zipCode;
      $scope.skipFinancialValidation = true;
    }
    nextStep();
  }

  function previousStep () {
    $location.path('/application/update-pay-packet');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      $scope.addressError = false;
      $scope.skipPayeeAddress = false;
      $scope.skipFinancialValidation = false;
      nextStep();
    }
  }

  function nextStep () {
    $window.scrollTo(0, 0);

    var data = {
      brokerInformation: angular.copy($scope.brokerInformation),
      commissionInformation: angular.copy($scope.commissionInformation),
      agencyInformation: angular.copy($scope.agencyInformation),
      generalInformation: angular.copy($scope.generalInformation)
    };

    if ($scope.commissionInformation.assignee === 'myself') {
      data.brokerInformation.ssn = $scope.generalInformation.ssn;
      data.brokerInformation.streetAddress = $scope.generalInformation.assigneeAddress;
      data.brokerInformation.streetAddress2 = $scope.generalInformation.assigneeAddress2;
      data.brokerInformation.city = $scope.generalInformation.assigneeCity;
      data.brokerInformation.state = $scope.generalInformation.assigneeState;
      data.brokerInformation.zipCode = $scope.generalInformation.assigneeZipCode;
      data.brokerInformation.resTelephone = $scope.generalInformation.assigneePhone;
      data.brokerInformation.email = $scope.generalInformation.assigneeEmail;
    }

    if ($scope.commissionInformation.assignee === 'agency') {
      data.agencyInformation.usingAgency = true;
      data.agencyInformation.businessFedTaxID = $scope.generalInformation.assigneeTaxID;
      data.agencyInformation.taxClassification = $scope.generalInformation.taxClassification;
      data.agencyInformation.businessAddress = $scope.generalInformation.assigneeAddress;
      data.agencyInformation.businessAddress2 = $scope.generalInformation.assigneeAddress2;
      data.agencyInformation.businessCity = $scope.generalInformation.assigneeCity;
      data.agencyInformation.businessState = $scope.generalInformation.assigneeState;
      data.agencyInformation.businessZipCode = $scope.generalInformation.assigneeZipCode;
      data.agencyInformation.businessPhone = $scope.generalInformation.assigneePhone;
      data.agencyInformation.businessEmail = $scope.generalInformation.assigneeEmail;
    }

    if ($scope.commissionInformation.assignee === 'third_party') {
      data.commissionInformation.usingAgency = true;
      data.commissionInformation.assigneeTaxID = $scope.generalInformation.assigneeTaxID;
      data.commissionInformation.taxClassification = $scope.generalInformation.taxClassification;
      data.commissionInformation.assigneeAddress = $scope.generalInformation.assigneeAddress;
      data.commissionInformation.assigneeAddress2 = $scope.generalInformation.assigneeAddress2;
      data.commissionInformation.assigneeCity = $scope.generalInformation.assigneeCity;
      data.commissionInformation.assigneeState = $scope.generalInformation.assigneeState;
      data.commissionInformation.assigneeZipCode = $scope.generalInformation.assigneeZipCode;
      data.commissionInformation.assigneePhone = $scope.generalInformation.assigneePhone;
      data.commissionInformation.assigneeEmail = $scope.generalInformation.assigneeEmail;
    }

    if ($scope.commissionInformation.updateCommissionInformation) {
      data.commissionInformation.payViaCheck = false;
      data.commissionInformation.useDirectDeposit = false;
    } else {
      data.commissionInformation.payViaCheck = true;
      data.commissionInformation.useDirectDeposit = true;
    }

    ApplicationService.setData(data);

    $scope.loading = true;

    validatePayeeAddress()
      .then(validateFinancialAddress)
      .then(submitAllData)
      .then(function () {
        $scope.loading = false;
        nextPage();
      }).catch(function () {
        $scope.loading = false;
      });
  }

  function submitAllData () {
    return ApplicationService.submit(false).catch(function () {
      $scope.failure = true;
    });
  }

  function validatePayeeAddress () {
    return $q(function (resolve, reject) {
      if ($scope.skipPayeeAddress) {
        resolve();
        return;
      }
      ApplicationService.validateAddress({
        address: $scope.generalInformation.assigneeAddress,
        address2: $scope.generalInformation.assigneeAddress2,
        city: $scope.generalInformation.assigneeCity,
        state: $scope.generalInformation.assigneeState,
        zipCode: $scope.generalInformation.assigneeZipCode
      }).then(function (response) {
        $scope.addressErrorDetails = null;
        resolve();
      }, function (response) {
        $scope.addressErrorDetails = response;
        $scope.addressErrorDetails.type = 'payee';
        reject();
      });
    });
  }

  function validateFinancialAddress () {
    $scope.addressExplanation = '';
    return $q(function (resolve, reject) {
      if ($scope.skipFinancialValidation) {
        resolve();
        return;
      }
      if ($scope.commissionInformation.updateCommissionInformation) {
        ApplicationService.validateAddress({
          address: $scope.commissionInformation.finInstStreetAddress,
          address2: $scope.commissionInformation.finInstStreetAddress2,
          city: $scope.commissionInformation.finInstCity,
          state: $scope.commissionInformation.finInstState,
          zipCode: $scope.commissionInformation.finInstZipCode
        }).then(function (response) {
          $scope.addressErrorDetails = null;
          resolve();
        }, function (response) {
          $scope.addressErrorDetails = response;
          $scope.addressErrorDetails.type = 'financial';
          reject();
        });
      } else {
        resolve();
      }
    });
  }

  function nextPage () {
    $location.path('/application/update-pay-packet/review');
  }

  init();
}

export default UpdatePayPacketInformationController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/UpdatePayPacketInformationController.js
// module id = 27
// module chunks = 0